import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Expenses
export const getExpenses = (params = {}) => axios.get(`${API}/expenses`, { params });
export const getExpense = (id) => axios.get(`${API}/expenses/${id}`);
export const createExpense = (data) => axios.post(`${API}/expenses`, data);
export const updateExpense = (id, data) => axios.put(`${API}/expenses/${id}`, data);
export const deleteExpense = (id) => axios.delete(`${API}/expenses/${id}`);
export const submitExpense = (id) => axios.post(`${API}/expenses/${id}/submit`);
export const approveExpense = (id, data) => axios.post(`${API}/expenses/${id}/approve`, data);
export const reimburseExpense = (id) => axios.post(`${API}/expenses/${id}/reimburse`);
export const bulkActionExpenses = (data) => axios.post(`${API}/expenses/bulk-action`, data);
export const bulkSubmitExpenses = (ids) => axios.post(`${API}/expenses/bulk-submit`, { expense_ids: ids });
export const resetExpenseToDraft = (id) => axios.post(`${API}/expenses/${id}/reset`);

// Categories
export const getCategories = () => axios.get(`${API}/categories`);
export const createCategory = (data) => axios.post(`${API}/categories`, data);
export const updateCategory = (id, data) => axios.put(`${API}/categories/${id}`, data);
export const deleteCategory = (id) => axios.delete(`${API}/categories/${id}`);

// Receipts
export const uploadReceipt = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${API}/receipts/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};
export const getReceipt = (id) => axios.get(`${API}/receipts/${id}`);
export const processOCR = (id, rotation = 0) => axios.post(`${API}/receipts/${id}/ocr`, null, { params: { rotation, force: rotation !== 0 } });
export const getReceiptImageUrl = (id) => `${API}/receipts/${id}/image`;

// Reports
export const getReportsSummary = (params = {}) => axios.get(`${API}/reports/summary`, { params });
export const exportExpenses = (params = {}) => axios.get(`${API}/reports/export`, { params, responseType: "blob" });

// Dashboard
export const getDashboardStats = (params = {}) => axios.get(`${API}/dashboard/stats`, { params });

// Policies
export const getPolicies = () => axios.get(`${API}/policies`);
export const updatePolicies = (data) => axios.put(`${API}/policies`, data);

// Currencies
export const getCurrencies = () => axios.get(`${API}/currencies`);

// Users
export const getUsers = () => axios.get(`${API}/users`);
export const updateUserRole = (id, role) => axios.put(`${API}/users/${id}/role`, null, { params: { role } });
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`);
export const createUser = (data) => axios.post(`${API}/auth/register`, data);
export const updateUser = (id, data) => axios.put(`${API}/users/${id}`, data);
export const updateUserSageAccount = (id, sage_account) => axios.put(`${API}/users/${id}/sage_account`, null, { params: { sage_account } });
export const updateUserSageNumEcriture = (id, sage_num_ecriture) => axios.put(`${API}/users/${id}/sage_num_ecriture`, null, { params: { sage_num_ecriture } });
export const updateMyProfile = (data) => axios.put(`${API}/auth/me`, data);
export const updateMyVehicle = (data) => axios.put(`${API}/auth/me/vehicle`, data);

// Public
export const getPublicCompanyInfo = () => axios.get(`${API}/public/company-info`);

// Seed
export const seedData = () => axios.post(`${API}/seed`);
